(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

jQuery(document).ready(function () {
  var _configData;

  $('.activeSlider').slick({
    infinite: true,
    touchThreshold: 70,
    arrows: false,
    dots: true,
    fade: true,
    speed: 100,
    touchMove: false,
    swipe: false,
    draggable: false
  });

  var urlParams = new URLSearchParams(window.location.search);

  var configData = (_configData = {
    firstName: '',
    lastName: '',
    email: '',
    zip: '',
    productImage: $('.pl-img-slider[color-id="0"]').find('.pl-imgSlide[data-slick-index="0"]').find('img').attr('src'),
    configType: 'tc',
    configStep: 'color',
    model: urlParams.get('model') || '',
    modelName: document.querySelector("h1").innerText
  }, _defineProperty(_configData, 'productImage', jQuery(".pl-imgSlide").find("img").attr("src")), _defineProperty(_configData, 'color', "0"), _configData);

  try {
    var data = JSON.parse(localStorage.getItem('configData'));
    if (data) {
      data = {
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        zip: data.zip || ''
      };
      Object.assign(configData, data);
    }
  } catch (e) {}

  // var formFilled = getCookie('tc_form_filled');
  // var formSubmitted = getCookie('tc_form');

  sessionStorage.setItem('configData', JSON.stringify(configData));
  localStorage.setItem('configData', JSON.stringify(configData));

  // if (!formFilled || configData.email === '' || configData.zip === '') {
  //   $('.pl-form-modal').fadeIn();
  // }

  $('.pl-navNextBtn, .btn-next').attr('href', '/configurator/tc/floor-plan/' + buildURLParams());
  $('.pl-navNextBtn, .btn-next').removeClass('disabled');

  $('.color-modal-trigger').click(function (e) {
    e.preventDefault();
    $('.coach-color-modal .slick-light').slick('unslick');
    $('.coach-color-modal').show();
  });

  $('.pl-colorBlock').click(function (e) {
    e.preventDefault();
    var sliderId = $(this).attr('rel-id');
    $('.activeSlider').hide();
    $('.activeSlider').slick('unslick');
    $('.activeSlider').removeClass('activeSlider');
    $('.pl-img-slider[color-id="' + sliderId + '"]').show();
    $('.pl-img-slider[color-id="' + sliderId + '"]').addClass('activeSlider');

    $('.pl-img-slider[color-id="' + sliderId + '"]').slick({
      infinite: true,
      touchThreshold: 70,
      arrows: false,
      dots: true,
      fade: true,
      speed: 100,
      touchMove: false,
      swipe: false,
      draggable: false
    });

    if (!$(this).hasClass('selected')) {
      $('.selected').removeClass('selected');
      $(this).children('.darkCheckMark').addClass('selected');
    }

    var newParams = location.href.split('?')[1] + '&color=' + sliderId,
        configData = JSON.parse(sessionStorage.getItem('configData'));

    configData.color = sliderId;
    configData.productImage = $('.pl-img-slider[color-id="' + sliderId + '"]').find('.pl-imgSlide[data-slick-index="0"]').find('img').attr('src');

    sessionStorage.setItem('configData', JSON.stringify(configData));
    localStorage.setItem('configData', JSON.stringify(configData));

    var selectedColorImage = $('.activeSlider .slick-track .slick-slide[data-slick-index="0"] img').attr('src');
    $('.coach-color-modal .modalImage').attr('src', selectedColorImage);

    $('.pl-navNextBtn, .btn-next').attr('href', '/configurator/tc/floor-plan/' + buildURLParams());
    $('.pl-navNextBtn, .btn-next').removeClass('disabled');
  });

  // jQuery('.btn-length').click(function(e){
  // 	e.preventDefault();
  // 	var imgToShow = jQuery(this).attr('data-img');
  // 	jQuery('#main-ext-img').attr('src', imgToShow);
  // 	var sleeps = jQuery(this).attr('data-sleeps');
  // 	jQuery('.sleep-capacity').text(sleeps);

  // 	var currentParams = location.href.split('?')[1];
  // 	var selectedLength = jQuery(this).attr('data-value');
  // 	var newParams = currentParams + '&length=' + selectedLength;

  // 	var configData = JSON.parse(sessionStorage.getItem('configData'));

  // 	configData.length = selectedLength;

  // 	sessionStorage.setItem('configData', JSON.stringify(configData));

  // 	jQuery('.pl-navNextBtn, .btn-next').attr('href', '/configurator/floor-plan/' + buildURLParams());
  // 	jQuery('.pl-navNextBtn, .btn-next').removeClass('disabled');
  // })
});

},{}]},{},[1]);
